import React from "react";
import styled, { keyframes } from "styled-components";
import { AnimatedCard } from "../ActionPlan/styles";

const epicIn = keyframes`
  0% { opacity: 0; transform: translateY(20px) scale(0.98); }
  60% { opacity: 1; transform: translateY(0) scale(1.02); }
  100% { opacity: 1; transform: translateY(0) scale(1); }
`;

const IntroHeader = styled.h1`
  font-family: 'Geist Variable', 'Geist', sans-serif;
  font-weight: 500;
  font-size: clamp(30px, 6vw, 40px);
  text-align: left;
  line-height: 1.05;
  margin: 0;
  letter-spacing: 0.5px;
  color: oklch(.145 0 0);
  animation: ${epicIn} 800ms ease-out both;
`;

const IntroText = styled.p`
  font-family: 'Geist Variable', 'Geist', sans-serif;
  font-size: clamp(15px, 2.2vw, 18px);
  color: #374151;
  margin: 10px 0 0 0;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 16px;
  flex-wrap: wrap;
`;

const DownloadButton = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 40px;
  padding: 0 14px;
  border-radius: 8px;
  background: #ffffff;
  color: ${(p) => p.$accentColor || '#2d70e2'};
  border: 1px solid currentColor;
  text-decoration: none;
  font-weight: 600;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.04);
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.02s ease;

  &:hover {
    background: #f8fafc;
  }

  &:active {
    transform: translateY(1px);
  }
`;

export default function Introduction({ themeColors, reportUrl }) {
  return (
    <AnimatedCard isFadingOut={false}>
      <div>
        <IntroHeader>Action Check-In</IntroHeader>
        <IntroText>Review your existing action plan, update statuses, and share quick feedback.</IntroText>
        <Actions>
          <DownloadButton
            href={reportUrl || "#"}
            target="_blank"
            rel="noopener noreferrer"
            $accentColor={themeColors?.buttonColor}
          >
            Download Your Report
          </DownloadButton>
        </Actions>
      </div>
    </AnimatedCard>
  );
}

